import React from "react";

const FIELDS = [
  { key: "contractHours", label: "Horas de contrato", step: 1, min: 0 },
  { key: "operatorCount", label: "Quantidade de operadores", step: 1, min: 0 },
  { key: "productivityAvg", label: "Produtividade média", step: 0.1, min: 0 },
  { key: "maintenanceHours", label: "Manutenção programada (h)", step: 0.5, min: 0 },
  { key: "lossesPercent", label: "Perdas (%)", step: 0.1, min: 0, max: 100 },
  { key: "riskFactor", label: "Fator de risco (mock)", step: 0.1, min: 0, max: 100 },
  { key: "tolerancePercent", label: "Tolerância p/ bater plano (%)", step: 0.1, min: 0, max: 100 },
];

function parseInput(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}

export default function QuickAdjustPanel({ parameters, onChange, onRun }) {
  return (
    <section className="swb-panel">
      <div className="swb-panel__head">
        <h3>Ajustes rápidos</h3>
        <button type="button" className="swb-btn swb-btn--primary" onClick={onRun}>
          Reexecutar
        </button>
      </div>

      <div className="swb-fields-grid">
        {FIELDS.map((field) => (
          <label key={field.key} className="swb-field">
            <span>{field.label}</span>
            <input
              type="number"
              min={field.min}
              max={field.max}
              step={field.step}
              value={parameters?.[field.key] ?? 0}
              onChange={(e) => onChange({ [field.key]: parseInput(e.target.value) })}
            />
          </label>
        ))}
      </div>
    </section>
  );
}
